import React, { useEffect, useRef, useState } from 'react';
import FastbetDropdown from '../../common/FastbetDropdown';
import OddsList from '../../common/OddsList';
import PartialScores from '../../common/PartialScores';
import Img from '../../common/util/Img';
import PrematchContext from '../../contexts/PrematchContext';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { SERVING_SPORTS } from '../../data/constants';
import { isSeoSettingsNoFollow } from '../../data/seo/seoUtils';
import { useAbsolutePath } from '../../data/seo/seoRouteUtils';
import { classIf, getConfiguration } from '../../data/utils';
import { checkForDashClass } from '../../tables-utils';
import { useUISettings } from '../../UISettingsProvider';
import MoreBets from './MoreBets';
import Jersey from '../../common/jerseys/Jersey';
import StatsToggle from '../../common/StatsToggle';
import LiveScoresInlineNewWh from '../../common/LiveScoresInlineNewWh';

function TournamentLiveBets(props) {
    const betslipContext = React.useContext(BetslipContext);
    const prematchContext = React.useContext(PrematchContext);
    const uiSettings = useUISettings();

    const [toggled, setToggled] = useState(prematchContext.match?.openedFromBanner ?? false);

    const match = props.match;
    const absoluteMatchPath = useAbsolutePath(match.urlPath, null, match.urlPathSeo);
    const noFollow = isSeoSettingsNoFollow(match.urlPathSeoSettings);

    function handleClick(url) {
        if (uiSettings.fullScreen) {
            setToggled(!toggled);
        } else {
            props.openMatch(match, url, match.urlPath);
        }
    }

    function toggleMoreBets() {
        if (uiSettings.fullScreen) {
            setToggled(!toggled);
        }
    }

    // Adatta il nome del match in base allo spazio disponibile
    const matchDesc = useRef(null);
    useEffect(() => {
        const handler = () => {
            if (matchDesc.current != null) {
                checkForDashClass(matchDesc.current);
            }
        };

        handler();
        window.addEventListener('resize', handler);
        return () => {
            window.removeEventListener('resize', handler);
        }
    }, [uiSettings.fullScreen, props.aggregata]);

    let fiveColumnTemplate = false;
    if (match?.gruppiScommessa.length <= 1) {
        fiveColumnTemplate = true;
    }
    const eventSelected = betslipContext.isEventSelected(match.pal, match.avv);
    const moreBetsToggled = uiSettings.fullScreen && toggled;
    const conf = getConfiguration();

    return (
        <>
            <div key={`tournament-match-${match.id}`} className={"tabellaQuoteNew text_s1 mb-2" + classIf(eventSelected, 'event-row-selected')}>
                {match.score !=null && (
                    conf.iwh ? (
                        <>
                            <span className="lampeggia tempo-live tempo-live-wh">{match.score.currentMinute}</span>
                            <LiveScoresInlineNewWh data={match.score} sportType={match.sportDesc} />
                        </>
                    ) : (
                        <div className="tabellaQuoteTempo d-flex justify-content-center align-items-center">
                            <div className="tempo-live text-center">
                                <span className="fraz-gioco colore-1 margine-dx-mezzo">{match.score.periodo}</span>
                                {match.score.currentMinute && (
                                    <span className="lampeggia tempo-live">{match.score.currentMinute}</span>
                                )}
                                <div className="risultato-live grassetto">
                                    <span>{match.score.combinedScore}</span>
                                </div>
                            </div>
                        </div>
                    )
                )}
                <div className="tabellaQuoteCampetto">
                    <span className="live-badge"></span>
                </div>
                <div ref={matchDesc} className="tabellaQuoteSquadre pointer" onClick={handleClick.bind(this, absoluteMatchPath)} {...(noFollow ? { rel: 'nofollow' } : {})} >
                    {match.score && SERVING_SPORTS.includes(match.sportRef) ?
                        <>
                            <p className={`font-weight-bold m-0 text-right ${match.score.srv === 1 ? 'serving' : 'not-serving'}`} title={match.team1}>
                                <span><Img src={match.score.sourceServing} alt=""></Img>{match.team1}</span>
                            </p>
                            {match.team2 != null &&
                                <>
                                    <p className="font-weight-bold colore-1 m-0 px-2 tabellaQuoteSquadreSeparatore">vs</p>
                                    <p className={`font-weight-bold m-0 text-left ${match.score.srv === 2 ? 'serving' : 'not-serving'}`} title={match.team2}>
                                        <span><Img src={match.score.sourceServing} alt=""></Img>{match.team2}</span></p>
                                </>
                            }
                        </>
                        :
                        <>
                            <div className="d-flex items-center">
                                {match.team2 &&
                                    <Jersey data={match.jerseys?.[0]} type={'home'} sportRef={match.sportRef} />
                                }
                                <p className="font-weight-bold m-0 text-right" title={match.team1}><span>{match.team1}</span></p>
                            </div>
                            {match.team2 != null &&
                                <>
                                    <p className="font-weight-bold colore-1 m-0 px-2 tabellaQuoteSquadreSeparatore">vs</p>
                                    <div className="d-flex items-center">
                                        <Jersey data={match.jerseys?.[1]} type={'away'} sportRef={match.sportRef} />
                                        <p className="font-weight-bold m-0 text-left" title={match.team2}><span>{match.team2}</span></p>
                                    </div>
                                </>
                            }
                        </>
                    }
                </div>
                <div className="tabellaQuoteStatistiche">
                    <StatsToggle className="fas fa-chart-bar stat-sel pointer" match={match} />
                </div>
                {!fiveColumnTemplate &&
                    <div className="tabellaQuoteAltre d-flex justify-content-end align-items-center pr-2">
                        <FastbetDropdown id={match.id} match={match} toggleMoreBets={toggleMoreBets} moreBetsToggled={toggled} />
                    </div>
                }
                <div className="tabellaQuoteContenitoreQuotazioni">
                    <OddsList {...match} />
                </div>
                {match.score != null && !conf.iwh &&
                    <div className="tabellaQuoteRisultatiParziali">
                        <div className="tabellaQuoteRisultatiParziali-contenitoreRisultati">
                            <PartialScores match={match} />
                        </div>
                    </div>
                }
            </div>
            {fiveColumnTemplate && moreBetsToggled &&
                <MoreBets match={match} aggregata={props.aggregata} />
            }
        </>
    );
}

export default TournamentLiveBets;